import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {View} from 'react-native';
import {ActivityIndicator, SwitchButton} from 'trpc-react-native-ui';
import {UsageChart, UsageDetail, UsageSwiper} from '../../components/usage';
import {ValidationButton} from '../../components/common';
import I18n from '../../lib/i18n';
import {extractIddZone} from '../../lib/IddZoneExtractor';
import RtlAwareStyleSheet from '../../lib/rtl-aware-stylesheet';
import theme, {getUsageStyle} from '../../theme-config';
import config from '../../config';

function getStyles() {
  return RtlAwareStyleSheet.create({
    bottomContentContainer: {
      flex: 1,
    },
    chartContainer: {
      alignItems: 'stretch',
      flex: 1,
      justifyContent: 'center',
    },
    container: {
      flex: 1,
      justifyContent: 'flex-start',
      backgroundColor: theme.backgroundColor,
    },
    footer: {
      borderTopColor: '#ddd',
      borderTopWidth: 1,
    },
    innerContainer: {
      flex: 1,
      justifyContent: 'space-between',
    },
    switchButtonContainer: {
      justifyContent: 'center',
      marginHorizontal: 40,
    },
    topContentContainer: {
      paddingTop: 20,
    },
  });
}

class YourUsage extends Component {
  componentDidMount() {
    this.props.updateUsageDisplayMode('daily');
  }

  changePlan = () => {
    if (this.props.subscription?.renewalStatus === 'ON') {
      this.props.changePlan(this.props.subscription);
    } else {
      this.props.navigation.navigate('yourPlan');
    }
  };

  topUp = () => this.props.navigation.navigate('topUp');

  goToInternationalTopUp = () => {
    const activeUsage =
      this.props.activeUsage === undefined
        ? PropTypes.object
        : this.props.activeUsage.label;
    this.props.goToInternationalTopUpOfZone(extractIddZone(activeUsage.label));
  };

  render() {
    const props = this.props;
    const styles = getStyles();
    const usagesArray = !props.usages.length ? null : props.usages;
    const activeUsage =
      props.activeUsage === undefined
        ? PropTypes.object
        : props.activeUsage.label;
    const usageGraphDisplayMode =
      this.props.usageGraphDisplayMode === undefined
        ? 'daily'
        : this.props.usageGraphDisplayMode;
    const extraUsageSelected = activeUsage && activeUsage.includes('IDD');
    const selectedSwitchButton = usageGraphDisplayMode === 'monthly' ? 0 : 1;
    const showChangePlanButton = usageGraphDisplayMode === 'monthly';
    const showTopUpButton = usageGraphDisplayMode === 'daily';
    let validationButtonProps = {};
    if (showChangePlanButton) {
      validationButtonProps.text = I18n.t('changePlan');
      validationButtonProps.onPress = this.changePlan;
    }
    if (showTopUpButton) {
      validationButtonProps.text = I18n.t('topUp');
      validationButtonProps.onPress = this.topUp;
      validationButtonProps.testID = 'yourUsage-topup-button';
    }
    if (extraUsageSelected) {
      validationButtonProps.text = I18n.t('Dashboard.YourUsage.boostPackage');
      validationButtonProps.onPress = this.goToInternationalTopUp;
    }
    return (
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <View style={styles.topContentContainer}>
            <UsageSwiper
              usages={usagesArray}
              activeUsage={activeUsage.label}
              onUsagePress={props.onUsagePress}
              renderSpinner={ActivityIndicator}
            />
          </View>
          {extraUsageSelected ? (
            <UsageDetail />
          ) : (
            config.showUsageGraph && (
              <View style={styles.bottomContentContainer}>
                <View style={styles.switchButtonContainer}>
                  <SwitchButton
                    defaultIndex={selectedSwitchButton}
                    buttons={[
                      {
                        label: I18n.t('history'),
                        usageDisplayMode: 'monthly',
                      },
                      {
                        label: I18n.t('thisMonth'),
                        usageDisplayMode: 'daily',
                      },
                    ]}
                    onChange={({usageDisplayMode}) =>
                      props.updateUsageDisplayMode(usageDisplayMode)
                    }
                  />
                </View>
                <View style={styles.chartContainer}>
                  <UsageChart
                    max={activeUsage.maxValue}
                    unitType={activeUsage.unitType}
                    color={getUsageStyle(activeUsage.label, theme).borderColor}
                    displayMode={usageGraphDisplayMode}
                    type={activeUsage.label}
                  />
                </View>
              </View>
            )
          )}
        </View>
        <View style={styles.footer}>
          <ValidationButton
            disabled={
              props.hasUnauthenticatedPayment || !this.props.canBoostPlan
            }
            {...validationButtonProps}
          />
        </View>
      </View>
    );
  }
}

YourUsage.propTypes = {
  subscription: PropTypes.object,
  usages: PropTypes.instanceOf(Array),
  activeUsage: PropTypes.object,
  onUsagePress: PropTypes.func.isRequired,
  usageGraphDisplayMode: PropTypes.oneOf(['daily', 'monthly']),
  updateUsageDisplayMode: PropTypes.func.isRequired,
  changePlan: PropTypes.func.isRequired,
  canBoostPlan: PropTypes.bool,
};

export default YourUsage;
